export enum Runtime {
    Node145 = 'node-14.5',
    Node160 = 'node-16.0',
    Node180 = 'node-18.0',
    Node190 = 'node-19.0',
    Node200 = 'node-20.0',
    Node210 = 'node-21.0',
    Php80 = 'php-8.0',
    Php81 = 'php-8.1',
    Php82 = 'php-8.2',
    Php83 = 'php-8.3',
    Ruby30 = 'ruby-3.0',
    Ruby31 = 'ruby-3.1',
    Ruby32 = 'ruby-3.2',
    Ruby33 = 'ruby-3.3',
    Python38 = 'python-3.8',
    Python39 = 'python-3.9',
    Python310 = 'python-3.10',
    Python311 = 'python-3.11',
    Python312 = 'python-3.12',
    Pythonml311 = 'python-ml-3.11',
    Deno140 = 'deno-1.40',
    Dart215 = 'dart-2.15',
    Dart216 = 'dart-2.16',
    Dart217 = 'dart-2.17',
    Dart218 = 'dart-2.18',
    Dart30 = 'dart-3.0',
    Dart31 = 'dart-3.1',
    Dart33 = 'dart-3.3',
    Dotnet31 = 'dotnet-3.1',
    Dotnet60 = 'dotnet-6.0',
    Dotnet70 = 'dotnet-7.0',
    Java80 = 'java-8.0',
    Java110 = 'java-11.0',
    Java170 = 'java-17.0',
    Java180 = 'java-18.0',
    Java210 = 'java-21.0',
    Swift55 = 'swift-5.5',
    Swift58 = 'swift-5.8',
    Swift59 = 'swift-5.9',
    Kotlin16 = 'kotlin-1.6',
    Kotlin18 = 'kotlin-1.8',
    Kotlin19 = 'kotlin-1.9',
    Cpp17 = 'cpp-17',
    Cpp20 = 'cpp-20',
    Bun10 = 'bun-1.0',
    Go123 = 'go-1.23',
}